/* file description */

import React from 'react';
import ProductSelelctMemo from '../component/ProductSelect';
import ProductSelelctRender from '../component/ProductSelect/render';
import { TransformNalmalType2TableColumn } from './type';
import { VALUE_TYPES, COLUMN_FROM } from './consts';
import _ from 'lodash';
import { Api as FetchAPI } from '@/utils';

export const transformProductSelectColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
  // FetchAPI,
  setRowData,
  moduleInfo,
}) => {
  // console.groupCollapsed(`${field?.label}#${field?.name} transformAseetRadioColumn`);
  // console.log('入参field', _.cloneDeep(field));
  // console.log('入参targetColumn', _.cloneDeep(targetColumn));

  targetColumn.valueType = VALUE_TYPES.SELECT;

  targetColumn.renderFormItem = (_a, config, form) => {
    return <ProductSelelctMemo moduleInfo={moduleInfo} setRowData={setRowData} storeValue={config.storeValue} field={field} form={form} config={config} API={{ FetchAPI }} columnFrom={config.from} />;
  };
  targetColumn.render = (dom, entity) => {
    const targerValue = entity?.value;
    const { setViewValue } = entity;
    return (
      <ProductSelelctRender setViewValue={setViewValue} field={field} API={{ FetchAPI }} targerValue={targerValue} rowsData={entity.formValue} columnFrom={entity.from} />
    );
  };

  // console.log('处理后targetColumn', _.cloneDeep(targetColumn));
  // console.groupEnd();

  return targetColumn;
};
